const MAP_STYLE = [
  {
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#444444"
      }
    ]
  },
  {
    "featureType": "administrative.locality",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "administrative.neighborhood",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [
      {
        "color": "#F2F2F2"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "color": "#E9E6DA"
      }
    ]
  },
  {
    "featureType": "landscape.natural.landcover",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#C8E0B1"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.attraction",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "poi.business",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "all",
    "stylers": [
      {
        "saturation": -100
      },
      {
        "lightness": 45
      },
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "all",
    "stylers": [
      {
        "color": "#9FE4E9"
      },
      {
        "visibility": "on"
      }
    ]
  }
]

const MAP_OPTIONS = {
  selectors: {
    form: '.mlmi-locator-form',
    list: '.locations-list',
    where: 'input[name="where"]',
    radius: 'select[name="radius"]',
  },
  basicOptions: {
    mapStyle: MAP_STYLE,
    zoom: 8,
    maxZoom: 18,
    minZoom: 5,
    lat: 45.60495258760901,
    lng: -73.71906734960938,
    autoFitBounds: false,
    enableGeolocation: false,
    putSearchParametersInURL: false,
  },
  clusterOptions: {
    useClusters: true,
    styles: [{
      url: '/img/elements/map-dot.svg',
			backgroundSize: '20px 20px',
			height: 20,
			width: 20,
			textColor: 'white',
			textSize: 10,
      fontFamily: 'sans-serif',
      lineHeight: 20,
      textWeight: 400,
      letterSpacing: '-.03em',
		}],
    minimumClusterSize: 3
  },
  bubbleOptions: {
    useBubbles: true,
    padding: 0,
    overflow: 'visible',
    borderRadius: 14,
    borderWidth: 0,
    backgroundColor: 'transparent',
    minWidth: 1,
    maxWidth: 1,
    minHeight: 20,
    maxHeight: 20,
    arrowSize: 0,
    arrowPosition: 50,
    arrowStyle: 0,
    disableAutoPan: true,
    hideCloseButton: false,
    closeClass: 'js-btn-close-info-bubble',
    closeIconClass: 'icon-close',
    disableAnimation: true,
  },
  getMarkerIcon: function(location) {
    let markerIcon = {
      url: '/img/elements/map-dot.svg',
      height: 20,
      width: 20,
      anchorY: 10,
      anchorX: 10,
    }
    return markerIcon
  },
}

$.fn.LocationItem = function() {
  let self = this

  if (self.data('location-item')) {
    return self.data('location-item')
  }

  self.name_clicked = function() {
    if (self.hasClass('location-item--expanded')) {
      self.removeClass('location-item--expanded')
      self.find('.location-item__info-wrapper').slideUp({
        duration: 350,
        easing: 'easeInOutQuart',
      })
    } else {
      self.addClass('location-item--expanded')
      self.find('.location-item__info-wrapper').slideDown(300)
    }
  }

  return function() {
    self.find('.location-item__name').on('click', self.name_clicked);
    self.data('location-item', self)
    return self
  }()
}

let self

export default {
  locator: undefined,
  locations: [],

  init() {
    self = this
    this.attachEvents()
  },

  markerClicked(event, locator, marker) {
    $('.location-item').removeClass('location-item--selected')
    let locationItem = $('.location-item[data-id=' + marker.location.id + ']')
    if (locationItem.length) {
      locationItem.addClass('location-item--selected')
      if (!locationItem.hasClass('location-item--expanded')) {
        locationItem.data('location-item').name_clicked()
      }
      $('html, body').scrollTo(locationItem.offset().top - $('.header').height(), 'easeInOutQuart')
    }
  },

  attachEvents() {
    if ($('.mlmi-locator-map').length) {
      /* Initialize map when ready */
      if ("MLMI_Locator_Function" in window) {
        $.fn.MLMI_Locator = window.MLMI_Locator_Function
      }
      if ($.fn.MLMI_Locator == undefined) {
        setTimeout(self.attachEvents, 50)
      } else {
        /* Initialize map */
        if ($.mlmi.mobile.isMobile) {
          MAP_OPTIONS.basicOptions.zoom = 9
        }
        let hasSearched = false,
        hasPanned = false

        /* Bubbles */
        const bubbleMaker = function(location) {
          let bubble = $('#mlmi-locator-infobubble-template').clone()
          bubble.text(location.display_name).show()
          return bubble.get(0)
        }

        self.locator = $('.mlmi-locator-map').MLMI_Locator(MAP_OPTIONS, bubbleMaker)

        function listInitialize() {
          $('.location-item').each(function() {
            $(this).LocationItem()
          })
        }
        self.locator.on('list_loaded', listInitialize)
        listInitialize()

        /* Search */
        self.locator.on('search_started', function() {
          if ($('input[name="where"]').val()) {
            self.locator.current.radius = undefined
            hasSearched = true
          }
          self.locator.addClass('mlmi-locator-map--loading')
          $('.search-location__submit').addClass('--searching')
          let targetTop = self.locator.offset().top - $('.header').height()
          $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
        })
        self.locator.on('list_loaded', function() {
          if (hasSearched) {
            $('.locations-list__reset-filters').removeClass('--hidden')
          }
          self.locator.removeClass('mlmi-locator-map--loading')
          $('.js-geolocate, .search-location__submit').removeClass('--searching')
          if (hasPanned) {
            hasPanned = false
            setTimeout(function() {
              self.locator.options.basicOptions.autoFitBounds = true
            }, 150)
          } else {
            self.locator.options.basicOptions.autoFitBounds = true
          }
        })

        /* Geolocate */
        $('.js-geolocate').on('click', function(e) {
          hasSearched = true
          e.preventDefault()
          self.locator.geolocate()
          $('.js-geolocate').addClass('--searching')
          $('.js-geolocate__container > span').remove()
        })
        self.locator.on('geolocation_denied', function() {
          $('.js-geolocate').removeClass('--searching')
          $('.js-geolocate__container').append($('<span></span>').text(lesbacchantes_l10n.GEOLOC_DENIED))
        })

        /* Auto-search on drag */
        self.locator.on('map_drag', function(map) {
          if (hasSearched) {
            $('.search-map-zone').removeClass('--hidden')
          }
    		})
        $('.search-map-zone').on('click', function() {
          hasPanned = true
          $(this).addClass('--hidden')
          $('input[name="where"]').val('')
          let mapBounds = self.locator.map.getBounds()
          self.locator.current.radius = Math.max(20, Math.ceil(google.maps.geometry.spherical.computeDistanceBetween(mapBounds.getSouthWest(), mapBounds.getNorthEast()) / 1000 / 2 * 1.15))
          self.locator.current.place = ''
          self.locator.current.lng = self.locator.map.getCenter().lng()
          self.locator.current.lat = self.locator.map.getCenter().lat()
          self.locator.setPositionMarker()
          self.locator.submitSearch()
          self.locator.options.basicOptions.autoFitBounds = false
        })
        self.locator.on('after_markers_loaded', function() {
          self.locator.options.basicOptions.autoFitBounds = true
        })

        /* Reset search */
        $('.locations-list__reset-filters').on('click', function() {
          hasSearched = false
          $(this).addClass('--hidden')
          $('input[name="where"]').val('')
          self.locator.current.lng = undefined
        	self.locator.current.lat = undefined
        	self.locator.current.place = undefined
          self.locator.current.radius = undefined
          $('.mlmi-locator-form').submit()
        })

        /* Marker clicked */
        self.locator.on('marker_clicked', self.markerClicked)
      }
    }
  },
}
